import { RouteLocationNormalizedLoaded } from "vue-router";

export default class MiezzBreadcrumb {
    /**菜单Id */
    id?: string;
    /**标签 */
    label?: string;
    /**跳转路由 */
    to?: any;
}